export const getErrorCode = error => {
  var _error$response;
  return (_error$response = error.response) == null || (_error$response = _error$response.data) == null || (_error$response = _error$response.details) == null || (_error$response = _error$response.applicationError) == null ? void 0 : _error$response.code;
};
//# sourceMappingURL=errors.js.map